import React from "react";
import Breadcrumbs from "~/components/breadcrumbs/breadcrumbs";
import { BreadcrumbsRoute } from "~/components/breadcrumbs/breadcrumbs.types";
import styles from "./internal-view.module.css";
import WidgetContainer from "@components-monorepo/components/widget-container";

type Props = {
  copy: string;
  breadcrumbs: BreadcrumbsRoute[];
  children: React.ReactNode;
  cover?: string;
  textOverflow?: boolean;
};

export const InternalView = ({
  copy,
  cover,
  children,
  breadcrumbs,
  textOverflow = true
}: Props) => {
  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}>

      <div className={`${styles.internalView} ${styles.internalViewContainer}`}>
        <div className={`${styles.head} ${styles.internalContainer}`}>
          <Breadcrumbs className={`${styles.back} back`} routes={breadcrumbs} />
        </div>
        <div
          className={`${styles.cover} ${textOverflow && styles.textOverflow}`}
          style={
          cover ?
          {
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)), url(${cover})`
          } :
          undefined}>


          <span>{copy}</span>
        </div>
        <div className={styles.internalContainer}>{children}</div>
      </div>
    </WidgetContainer>);

};